import axiosClient from "./axiosClient";
const noticeApi = {

    GetNotice() {
        const url = '/notice';
        return axiosClient.get(url);
    },
    UpdateSeen(id) {
        const url = '/notice';
        return axiosClient.post(url, { id: id });
    },
}

export default noticeApi;
